export default __webpack_public_path__ + "static/media/Branded-orange.f0ea56e6.png";